import { IAlertEmergencyLiveItem, EmergencyAlertType } from '@/api/notification/getLiveEmergencyAlert.ts'
import { EmergencyAlertConfirmStatus } from '@/api/notification/getNotificationSos.ts'
import { IAlertFallDetectionLiveItem } from '@/api/notification/getLiveFallDetectionAlert.ts'

export interface IEmergencyAlertSelection {
    id: number
    type: EmergencyAlertType
    createdAt: string
}

const isUnprocessed = (confirm?: string) => confirm === undefined || confirm === EmergencyAlertConfirmStatus.WAIT

const toTimestamp = (createdAt: string) => {
    const timestamp = new Date(createdAt).getTime()
    return Number.isFinite(timestamp) ? timestamp : 0
}

export const selectLatestUnprocessedAlert = (
    sosAlerts: IAlertEmergencyLiveItem[] = [],
    fallAlerts: IAlertFallDetectionLiveItem[] = [],
    dismissedAlertIds: ReadonlySet<number> = new Set<number>()
): IEmergencyAlertSelection | undefined => {
    const candidates: IEmergencyAlertSelection[] = [
        ...sosAlerts
            .filter(item =>
                isUnprocessed(item.alert?.confirm)
                && !dismissedAlertIds.has(item.id)
                && (item.alert?.type === EmergencyAlertType.SOS || item.alert?.type === undefined)
            )
            .map(item => ({
                id: item.id,
                type: EmergencyAlertType.SOS,
                createdAt: item.alert.createdAt
            })),
        ...fallAlerts
            .filter(item => isUnprocessed(item.alert?.confirm) && !dismissedAlertIds.has(item.id))
            .map(item => ({
                id: item.id,
                type: EmergencyAlertType.FALL,
                createdAt: item.alert.createdAt
            }))
    ]

    return candidates.sort((left, right) => {
        const timeDifference = toTimestamp(right.createdAt) - toTimestamp(left.createdAt)
        return timeDifference !== 0 ? timeDifference : right.id - left.id
    })[0]
}

export const sortAlertsNewestFirst = <T extends { id: number; alert: { createdAt: string } }>(alerts: T[]) => (
    [...alerts].sort((left, right) => {
        const timeDifference = toTimestamp(right.alert.createdAt) - toTimestamp(left.alert.createdAt)
        return timeDifference !== 0 ? timeDifference : right.id - left.id
    })
)
